/**
 * @ngdoc overview
 * @name evtviewer.UItools
 * @module evtviewer.UItools
 * @description 
 * # evtviewer.UItools
 * Module referring to tools on User Interface connected to different kind of contents.
 *
 * ## Services
 * - {@link evtviewer.UItools.evtPinnedElements evtPinnedElements} where are defined and exposed 
 * methods to handle pinned elements.
 * - {@link evtviewer.UItools.evtImageTextLinking evtImageTextLinking} where are defined and exposed 
 * methods to handle image-text linking tool.
**/
angular.module('evtviewer.UItools', []);